// import useJwt from '@/auth/jwt/useJwt'
import store from '@store'
import cookie from '@/libs/cookie'
import axios from '@axios'
import router from '@/router'
import Vue from 'vue'

/**
 * Return if user is logged in
 * This is completely up to you and how you want to store the token in your frontend application
 * e.g. If you are using cookies to store the application please update this function
 */
// eslint-disable-next-line arrow-body-style
export const isUserLoggedIn = () => {
  if (store.state.user.token || cookie.get('token')) {
    return true
  }
  return false
}

export const getUserData = async () => {
  if (store.state.user.data) return store.state.user.data
  const instance = axios.create()
  instance.interceptors.response.use(response => {
    return response
  }, error => {
    if (error.response.status === 401) {
      Vue.$cookies.remove('token')
      store.commit('user/UPDATE_USER_DATA', null)
    }
    return Promise.resolve(error)
  })

  await instance.get('user')
    .then((data) => {
      store.commit('user/UPDATE_USER_DATA', data.data)
      store.commit('user/UPDATE_USER_REDIRECT_FROM', data.data.redirectFrom)
      return store.state.user.data
    })
    .catch((error) => {
      return false
    })

  return store.state.user.data ?? false
}

/**
 * This function is used for demo purpose route navigation
 * In real app you won't need this function because your app will navigate to same route for each users regardless of ability
 * Please note role field is just for showing purpose it's not used by anything in frontend
 * We are checking role just for ease
 * NOTE: If you have different pages to navigate based on user ability then this function can be useful. However, you need to update it.
 * @param {String} userRole Role of user
 */
export const getHomeRouteForLoggedInUser = userRole => {
  if (userRole === 'admin') return '/'
  if (userRole === 'client') return { name: 'access-control' }
  return { name: 'auth-login' }
}
